export type WizardMode = 'speak' | 'snap' | 'manual'
export type WizardStep = 'chooser' | 'capture' | 'contact' | 'company'

/** Steps after the chooser fork, in order, for a chosen mode. */
export function stepsForMode(mode: WizardMode): WizardStep[] {
  const capture: WizardStep[] = mode === 'manual' ? [] : ['capture']
  return [...capture, 'contact', 'company']
}

/** Number of "Step X of Y" steps for a mode (the chooser is excluded). */
export function totalSteps(mode: WizardMode): number {
  return stepsForMode(mode).length
}
